import {createSvgIcon} from '../create-svg-icon';

export const PlaylistAddCheckIcon = createSvgIcon(
  <path d="M3 10h11v2H3zm0-4h11v2H3zm0 8h7v2H3zm17.59-2.07-4.25 4.24-2.12-2.12-1.41 1.41L16.34 19 22 13.34z" />
, 'PlaylistAddCheckOutlined');
